import React from 'react'

export default function TelePhoneIcon() {
   return (
      <svg
         width="37"
         height="37"
         viewBox="0 0 37 37"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M21.9399 8.44948C21.2258 8.31757 20.57 8.77326 20.4341 9.47028C20.2982 10.1673 20.7553 10.8478 21.4499 10.9842C23.5413 11.392 25.1562 13.0109 25.5655 15.1094V15.1109C25.682 15.715 26.2138 16.1542 26.8263 16.1542C26.9084 16.1542 26.9906 16.1467 27.0743 16.1317C27.7689 15.9923 28.226 15.3133 28.0901 14.6147C27.4791 11.4804 25.0665 9.05956 21.9399 8.44948Z"
            fill="#F1ECDC"
         />
         <path
            d="M21.8463 3.22674C21.5117 3.17877 21.1755 3.2777 20.9081 3.49056C20.6333 3.70641 20.4615 4.01819 20.4241 4.36746C20.345 5.07347 20.8544 5.71203 21.5595 5.79148C26.4219 6.3341 30.2014 10.122 30.7481 14.9997C30.8213 15.6532 31.3696 16.1464 32.0239 16.1464C32.0732 16.1464 32.121 16.1434 32.1703 16.1374C32.5124 16.0999 32.8171 15.9305 33.0322 15.6607C33.2459 15.3909 33.343 15.0551 33.3041 14.7119C32.6229 8.62603 27.9128 3.90277 21.8463 3.22674Z"
            fill="#F1ECDC"
         />
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.8601 19.6734C22.8437 25.6554 24.2012 18.7349 28.011 22.5421C31.6839 26.214 33.7949 26.9496 29.1414 31.6019C28.5585 32.0704 24.8549 37.7062 11.8394 24.6943C-1.17772 11.6808 4.45488 7.97351 4.92345 7.39077C9.5883 2.72561 10.3113 4.84892 13.9842 8.52084C17.794 12.3296 10.8765 13.6915 16.8601 19.6734Z"
            fill="#F1ECDC"
         />
      </svg>
   )
}
